module.exports = "<ngx-spinner id=\"ngxspinner\" bdColor=\"rgba(51, 51, 51, 0.8)\" size=\"medium\" color=\"#fff\"\r\n    type=\"ball-spin-clockwise\"></ngx-spinner>"


//////////////////
// WEBPACK FOOTER
// ./src/app/callback/callbacks.component.html
// module id = ./src/app/callback/callbacks.component.html
// module chunks = main